<template>
    <section class="o-page-bottom-spacing">
        <page-header>
            <slot slot="title">{{ $t('branch.page_header_edit') }}</slot>
        </page-header>
        <div class="o-wrapper o-wrapper--center">
            <form action="" class="c-form c-form--horizontal">

                <div class="u-max-1000 c-form-row">
                    <v-loading :data="loaded" type="global"></v-loading>

                    <v-form-row>
                        <v-input v-model="Branch.Name" name="branch_name" :fluid="true" :disabled="true">
                            <slot slot="label">{{ $t('branch.label.name') }}</slot>
                        </v-input>
                    </v-form-row>

                    <v-form-row>
                        <h3 class="u-pull-left">{{ $t('branch.label.brands') }}</h3>
                        <div class="u-pull-right">
                            <v-add-brand
                                v-if="availableBrands.length > 0"
                                @brandsAdded="addBrands"
                                :brandOptions="availableBrands">
                            </v-add-brand>
                        </div>
                        <table-component v-if="AvailableCountryOptions && AvailableCountryOptions.length > 0 && branchBrands.length > 0" class="o-page-row" table-class="c-table c-table--small" :data="branchBrands" :show-caption="false" :show-filter="false">
                            <table-column key="Name" :sortable="false">
                                <template slot-scope="row">
                                    {{ row.Name }}
                                </template>
                            </table-column>
                            <table-column key="IsPartOfBranch" :sortable="false">
                                <template slot-scope="row">
                                    <div>
                                        <input type="checkbox" v-model="row.IsPartOfBranch"/>
                                    </div>
                                </template>
                            </table-column>
                            <table-column v-for="country in AvailableCountryOptions" :key="country.code" :label="country.code" :sortable="false">
                                <template slot-scope="row">
                                    <div>
                                        <span @click="onIsVisibleClick(row, country.code)"
                                            v-tooltip="{ content: $t('branch.label.is_visible'), classes: 'information' }">
                                            <svgicon name="lamp" class="svg-icon svg-fill"
                                                :color="getIsVisibleColor(row.Restrictions, country.code)">
                                            </svgicon>
                                        </span>
                                    </div>
                                    <div>
                                        <span @click="onIsForSaleClick(row, country.code)"
                                            v-tooltip="{ content: $t('branch.label.is_for_sale'), classes: 'information' }">
                                            <svgicon name="shopping-cart" class="svg-icon svg-fill"
                                                :color="getIsForSaleColor(row.Restrictions, country.code)">
                                            </svgicon>
                                        </span>
                                    </div>
                                </template>
                            </table-column>
                            <table-column cell-class="u-text-nowrap u-text-align-center" :sortable="false">
                                <template slot-scope="row">
                                    <button type="button" class="c-button c-button--tiny c-button--alpha" @click="deleteBrand(row.Code)">
                                        <svgicon name="cross" class="svg-icon svg-fill"></svgicon>
                                    </button>
                                </template>
                            </table-column>
                        </table-component>
                        <div v-else class="u-font-large u-text-align-center u-padding">
                            {{ $t('branch.label.no_brands_found') }}
                        </div>
                    </v-form-row>

                    <v-form-row>
                        <div class="c-form-item u-pull-right">
                            <v-label></v-label>
                            <button @click="submitForm" class="c-button c-button--alpha">{{ $t('branch.button.edit') }}</button>
                        </div>
                    </v-form-row>
                </div>
            </form>
        </div>
    </section>
</template>

<script>
    import VLoading from '@/components/Loading'
    import PageHeader from '@/components/common/PageHeader'
    import VInput from '@/components/form/Input'
    import VSelect from '@/components/form/Select'
    import VCustomSelect from '@/components/form/CustomSelect'
    import VFormRow from '@/components/form/Row'
    import VLabel from '@/components/form/Label'
    import VAddBrand from '@/components/branches/AddBrand'
    import _find from 'lodash/find'
    import {mapGetters} from 'vuex'

    export default {
        components: {
            VLoading,
            PageHeader,
            VInput,
            VSelect,
            VCustomSelect,
            VLabel,
            VAddBrand,
            VFormRow,            
        },
        data() {
            return {
                Validate: {},
                loaded: {}
            }
        },
        computed: {
            ...mapGetters({
                BrandsOptions: 'BrandsOptions',
                Branch: 'Branch',
                AvailableCountryOptions: 'AvailableCountryOptions'
            }),
            availableBrands(){
                let brands = [];

                if(this.loaded.isLoaded){
                    this.BrandsOptions.forEach((item) => {
                        let exists = this.Branch.Brands[item.Code];

                        if(!exists){
                            brands.push(item);
                        }
                    });
                }
                
                return brands;
            },
            branchBrands() {
                let branchBrands = [];

                if(this.loaded.isLoaded){
                    const brands = this.Branch.Brands;

                    Object.keys(brands).forEach(function(key) {
                        var brand = brands[key];
                        brand.Code = key;
                        branchBrands.push(brand);
                    });
                }

                return branchBrands;
            }
        },
        created: function () {
            this.$store.dispatch('getAvailableCountryOptions');
            this.$store.dispatch('getBrandsOptions');
            this.$store.dispatch('getBranch', this.$attrs.id).then(() => {
                this.loaded = { isLoaded: true }
            });
        },
        methods: {
            validateForm(response){
                let errors = response.data.ModelState;

                // Get error data from server, and transform to vue data
                Object.keys(errors).forEach(function(key) {
                    key = key.replace('model.', '');
                    errors[key] = errors['model.'+key][0];
                    delete errors['model.'+key];
                });

                this.Validate = errors;
            },
            submitForm(e) {
                this.loaded = {}
                this.$store.dispatch('updateBranch', this.Branch).then((response) => {
                    if (response.status > 300) {
                        this.validateForm(response);
                    } else {
                        this.$router.push({
                            name: 'BranchesOverview'
                        });
                    }
                    this.loaded = { isLoaded: true }
                }).catch(() => {
                    this.loaded = { isLoaded: true };
                });
                e.preventDefault();
            },
            getIsVisibleColor(restrictions, countryCode){
                let restriction = _find(restrictions, {'CountryCode': countryCode});
                
                if(restriction && (restriction.RestrictionLevel === 'view' || restriction.RestrictionLevel === 'sell')){
                    return '#EF7D01';
                }

                return '#292929';
            },
            getIsForSaleColor(restrictions, countryCode){
                let restriction = _find(restrictions, {'CountryCode': countryCode});

                if(restriction && restriction.RestrictionLevel === 'sell'){
                    return '#EF7D01';
                }

                return '#292929';
            },
            onIsVisibleClick(brand, countryCode){
                let restriction = _find(brand.Restrictions, {'CountryCode': countryCode});

                if(restriction){
                    if(restriction.RestrictionLevel === 'view' || restriction.RestrictionLevel === 'sell'){
                        restriction.RestrictionLevel = 'restricted'
                    } else {
                        restriction.RestrictionLevel = 'view'
                    }
                }
                else {
                    brand.Restrictions.push({
                        CountryCode: countryCode,
                        RestrictionLevel: 'view'
                    });
                }
            },
            onIsForSaleClick(brand, countryCode){
                let restriction = _find(brand.Restrictions, {'CountryCode': countryCode});

                if(restriction){
                    if(restriction.RestrictionLevel === 'sell'){
                        restriction.RestrictionLevel = 'view'
                    } else {
                        restriction.RestrictionLevel = 'sell'
                    }
                }
                else {
                    brand.Restrictions.push({
                        CountryCode: countryCode,
                        RestrictionLevel: 'sell'
                    });
                }
            },
            addBrands(newBrands){
                this.loaded = {};
                newBrands.forEach((newBrand) => {
                    this.Branch.Brands[newBrand.Code] = 
                    {
                        Name: newBrand.Name,
                        IsPartOfBranch: false,
                        Restrictions: []
                    };
                });
                this.loaded = { isLoaded: true };
            },
            deleteBrand(brandCode){
                this.loaded = {};
                delete this.Branch.Brands[brandCode];
                this.loaded = { isLoaded: true };
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/admin/branches/Edit.vue